import { t } from "./index739.mjs";
import { d as r } from "./index740.mjs";
import { o } from "./index741.mjs";
var i = t, e = r, n = o;
i || e(Object.prototype, "toString", n, { unsafe: !0 });
